var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0625 10.7543C20.1443 10.8469 20.2019 10.9582 20.2303 11.0784C20.2581 11.1981 20.256 11.3228 20.2243 11.4414C20.1926 11.5601 20.1322 11.6692 20.0485 11.7591L9.54847 23.0091C9.4372 23.1278 9.29032 23.2071 9.13001 23.2351C8.96969 23.263 8.80464 23.2381 8.65974 23.164C8.51485 23.0899 8.39799 22.9707 8.32679 22.8244C8.25559 22.6781 8.23391 22.5125 8.26503 22.3528L9.63566 15.4856L4.23284 13.4597C4.11681 13.4163 4.01334 13.3448 3.93166 13.2517C3.84999 13.1585 3.79267 13.0466 3.76481 12.9259C3.73696 12.8052 3.73943 12.6794 3.77203 12.5599C3.80462 12.4404 3.86631 12.3308 3.95159 12.2409L14.4516 0.990934C14.5629 0.872186 14.7097 0.792851 14.8701 0.7649C15.0304 0.736949 15.1954 0.761899 15.3403 0.835986C15.4852 0.910072 15.6021 1.02927 15.6733 1.1756C15.7445 1.32194 15.7662 1.48745 15.735 1.64718L14.3607 8.52187L19.7616 10.5478C19.8774 10.5908 19.9808 10.6618 20.0625 10.7543Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/Lightning.4d05e24b419ba288287d4922a25aa4ae.svg";
export { ForwardRef as ReactComponent };